import { CheckCircle } from "@mui/icons-material";
import { Box, Button, Container, Paper, Stack, ThemeProvider, Typography } from "@mui/material";
import { useSearchParams } from "react-router";
import { useSafeNavigateBack } from "../hooks/use-safe-navigate-back";
import { theme } from "../theme/theme";

export function OnboardingUnsubscribedPage() {
  const [searchParams] = useSearchParams();
  const navigateBack = useSafeNavigateBack("/configuration?tab=notifications");
  const orgId = searchParams.get("org_id");

  const handleGoToSettings = () => {
    navigateBack();
  };

  return (
    <ThemeProvider theme={theme}>
      <Container maxWidth="sm">
        <Stack alignItems="center" justifyContent="center" minHeight="100vh" spacing={3}>
          <Paper
            elevation={3}
            sx={{
              p: 4,
              maxWidth: 600,
              textAlign: "center",
              backgroundColor: "background.paper",
            }}
          >
            <Stack spacing={3} alignItems="center">
              <CheckCircle
                sx={{
                  fontSize: 48,
                  color: "success.main",
                }}
              />

              <Typography variant="h4" component="h1" gutterBottom>
                Unsubscribed Successfully
              </Typography>

              <Typography variant="body1" color="text.secondary">
                You've been unsubscribed from onboarding setup reminders. You won't receive any more
                emails about completing your setup.
              </Typography>

              {orgId && (
                <Typography
                  variant="caption"
                  color="text.secondary"
                  sx={{ fontFamily: "monospace" }}
                >
                  Organization: {orgId}
                </Typography>
              )}

              <Box sx={{ pt: 2, width: "100%" }}>
                <Button
                  variant="contained"
                  color="primary"
                  fullWidth
                  onClick={handleGoToSettings}
                  size="large"
                >
                  Re-enable Notifications in Settings
                </Button>
              </Box>

              <Typography variant="caption" color="text.secondary">
                You can change your notification preferences at any time in your account settings.
              </Typography>
            </Stack>
          </Paper>
        </Stack>
      </Container>
    </ThemeProvider>
  );
}
